import { SVGProps } from 'react';

const UnLock = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
      <g clipPath='url(#clip0_18470_196786)'>
        <path
          d='M8.64261 0.840943C10.5002 -0.172185 12.8186 -0.275756 14.7612 0.5621C17.6014 1.73457 19.4803 4.77926 19.3528 7.83326C19.2532 8.83311 17.9652 9.43461 17.1606 8.80788C16.4967 8.40688 16.5671 7.573 16.494 6.90776C16.2364 4.57345 14.0136 2.57508 11.6289 2.8194C9.4247 2.98405 7.64143 4.95586 7.45686 7.11756C7.3918 8.25285 7.44491 9.39345 7.42765 10.5314C11.2199 10.5354 15.0122 10.5261 18.8044 10.5354C19.6144 10.5314 20.3128 11.2816 20.285 12.0849C20.2876 15.5386 20.2876 18.9909 20.285 22.4446C20.3128 23.2944 19.5347 24.042 18.6876 23.9982C14.2128 23.9968 9.73673 23.9995 5.26197 23.9968C4.47723 24.0181 3.71373 23.3608 3.71771 22.5575C3.7124 19.0215 3.70975 15.4855 3.71904 11.9508C3.7124 11.3732 4.13332 10.9019 4.61665 10.6403C4.6764 8.88224 4.42013 7.07241 4.95923 5.36483C5.5355 3.4541 6.87262 1.77573 8.64261 0.840943ZM10.5826 14.9955C10.4498 15.6329 10.8109 16.2756 11.3686 16.5783C11.2637 17.4228 11.0592 18.2527 10.9185 19.0919C11.6382 19.0972 12.3579 19.0972 13.0775 19.0919C12.8903 18.2673 12.7084 17.4414 12.5345 16.6141C12.9155 16.4123 13.2634 16.0976 13.3763 15.6661C13.6233 14.9318 13.1373 14.0754 12.395 13.8788C11.6129 13.6239 10.7021 14.1816 10.5826 14.9955Z'
          fill={props.fill || '#232F3E'}
        />
      </g>
      <defs>
        <clipPath id='clip0_18470_196786'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UnLock;
